import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'momentDate',
    standalone: false
})
export class MomentDatePipe implements PipeTransform {
  private readonly momentDateTimeFormats = new Map()
    .set('short', 'M/D/YY, h:mm a')
    .set('medium', 'MMM D, Y, h:mm:ss a')
    .set('long', 'MMMM D, Y, h:mm:ss a')
    .set('full', 'dddd, MMMM D, Y, h:mm:ss a')
    .set('shortDate', 'M/D/YY')
    .set('mediumDate', 'MMM D, Y')
    .set('longDate', 'MMMM D, Y')
    .set('fullDate', 'dddd, MMMM D, Y')
    .set('shortTime', 'h:mm a')
    .set('mediumTime', 'h:mm:ss a')

  transform(value: moment.Moment, dateFormatType: string): unknown {
    return moment(value).format(this.momentDateTimeFormats.get(dateFormatType));
  }
}
